import React from "react";
import "./Footer.css";
import { FaHome, FaUsers, FaEye, FaHeart, FaIdCard } from "react-icons/fa"; // You'll need to install react-icons

function Footer() {
  return (
    <footer className="footer-mission">
      <div className="footer-header">
        <h2 className="mission-title">Support Our Mission</h2>
        <p className="mission-subtitle">Help us help others</p>
      </div>

      <div className="footer-grid">
        {/* Column 1: About Us */}
        <div className="footer-col">
          <h3><FaHome className="footer-icon" /> ABOUT US</h3>
          <p>
            Jouzourouna is a humanitarian organization with a social purpose of
            helping the needy without discrimination between religious, political or
            geographical affiliation.
          </p>
        </div>

        {/* Column 2: Committee */}
        {/* <div className="footer-col">
          <h3><FaUsers className="footer-icon" /> COMMITTEE</h3>
          <ul className="footer-list">
            <li>Dr. Elie Elias | الدكتور إيلي إلياس</li>
            <li>Father Hani Tawk | الأب هاني طوق</li>
            <li>Najib Harb | نجيب حرب</li>
            <li>Nehmé Y. Taouk | نعمه يوسف طوق</li>
          </ul>
        </div> */}

        {/* Column 3: Our Goals */}
        <div className="footer-col">
          <h3><FaEye className="footer-icon" /> OUR GOALS</h3>
          <p>Click here to view the list of the goals of Jouzourouna's organization:</p>
          <ul className="footer-list dotted">
            <li><a href="#english">English</a></li>
            <li><a href="#french">French</a></li>
            <li><a href="#arabic">Arabic</a></li>
          </ul>
        </div>

        {/* Column 4: From the Heart */}
        <div className="footer-col">
          <h3><FaHeart className="footer-icon" /> FROM THE HEART</h3>
          <p>
            We greatly appreciate your donation by returning the enclosed envelope with a
            check made out to "Jouzourouna". We thank you for your generosity!
          </p>
          <ul className="footer-list dotted">
            <li><a href="#terms">View Terms & Conditions</a></li>
            <li><a href="#contact">Contact us</a></li>
          </ul>
        </div>

        {/* Column 5: Donate Details */}
        <div className="footer-col">
          <h3><FaIdCard className="footer-icon" /> DONATE DETAILS</h3>
          <div className="donate-info">
            <p><strong>IBAN:</strong> LB91 0075 0000 0001 1401 4061 7900</p>
            <p><strong>Account name:</strong> JOUZOUROUNA AL MASIHYIA</p>
            <p><strong>Swift code:</strong> BABE LBBE</p>
            <p>Bank of Beirut, Jdeideh branch Beirut, Lebanon</p>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;